import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Editor.vue?vue&type=style&index=1&id=7c38231b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c38231b"]])

export default __exports__